import axios from "axios";
import axiosRetry from "axios-retry";

const instance = axios.create({
    baseURL: process.env.VUE_APP_PICA_CORE_API_BASE_URL,
    headers: {
        'X-Requested-With': 'XMLHttpRequest'
    }
});

// Configure axios-retry
axiosRetry(instance,
    {
        retries: 4,
        retryDelay: (retryNumber) => Math.pow(2, retryNumber) * 1000,
        retryCondition: axiosRetry.isNetworkOrIdempotentRequestError
    }
);

const token = localStorage.getItem('token');
const tokenType = localStorage.getItem('token_type') || 'Token';
if (token) {
    instance.defaults.headers.common['Authorization'] = `${tokenType} ${token}`;
}

instance.interceptors.request.use(function (config) {
    const eventOwnerId = localStorage.getItem('eventOwnerId');
    if (eventOwnerId) {
        config.headers['pica-event-owner-id'] = eventOwnerId;
    }
    return config;
});

instance.interceptors.response.use(null, async function (error) {
    if (error && error.response && error.response.status) {
        console.warn("[interceptors.response] Error status", error.response.status);

        if (401 === error.response.status) {
            // Import dinamici per evitare dipendenze circolari
            const [store, router] = await Promise.all([
                import('../store').then(m => m.default),
                import('../router').then(m => m.default)
            ]);
            store.dispatch('auth/logout').then(() => router.push('/').catch(() => {
            }));
        } else {
            return Promise.reject(error);
        }
    }
});

export default instance;
